import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CreateClient,
  EditClientState,
} from "../../../api/services/client/models";
import storage from "redux-persist/lib/storage";

const initialState = {
  createClientData: {
    id: "",
    clientCode: "",
    clientTypeId: "",
    clientName: "",
    clientBillingCountryId: "",
  } as CreateClient,
  editClientData: {
    isEdit: false,
  } as EditClientState,
};

const createClientSlice = createSlice({
  name: "createClientSlice",
  initialState,
  reducers: {
    setCreateClientData(state, action: PayloadAction<CreateClient>) {
      state.createClientData = action.payload;
    },
    setIsEditClient(state, action: PayloadAction<EditClientState>) {
      state.editClientData.isEdit = action.payload.isEdit;
    },
  },
});

export const { setCreateClientData, setIsEditClient } =
  createClientSlice.actions;

export const persistCreateClientConfig = {
  version: 1,
  key: "mpg_next_admin_create_client_v1",
  storage,
  whitelist: ["createClientSlice"],
};

export default createClientSlice.reducer;
